import type { ProjectReportDTO } from "@/application/project-reports/dtos/ProjectReportDTO";
import type { ProjectReportsGatewayPort } from "@/application/project-reports/ports/ProjectReportsGatewayPort";

export class GetProjectReportsUseCase {
  constructor(private readonly gateway: ProjectReportsGatewayPort) {}

  async execute(projectId: string): Promise<ProjectReportDTO[]> {
    if (!projectId || projectId.trim().length === 0) {
      throw new Error("Project ID is required");
    }

    return this.gateway.list(projectId);
  }
}
